import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=165c8286&scoped=true&"
import script from "./footerMobile.vue?vue&type=script&lang=js&"
export * from "./footerMobile.vue?vue&type=script&lang=js&"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=165c8286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c8286",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Imglazy: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/Imglazy.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default,SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
